import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import modules from "./modules";
import createMutationsSharer from "vuex-shared-mutations";

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== "production",
  plugins: [
    createPersistedState({ paths: ["auth", "global"] }),
    createMutationsSharer({
      predicate: [
        "AUTH_SET_AUTHENTICATED",
        "AUTH_SET_CURRENT_ACCOUNT_CUSTOM_FIELDS",
        "AUTH_SET_TEAM",
        "AUTH_SET_API",
        "AUTH_SET_ACCOUNT",
        "AUTH_RESET_AUTH",
        "AUTH_LOGOUT_TEAM",
        "AUTH_SET_COGNITO",
        "GLOBAL_INIT_TEAMS_SETTINGS",
        "GLOBAL_RESET_GLOBAL_TEAM_SETTINGS",
      ],
    }),
  ],
});
